/**
 * Эвристика «мобильное устройство» для routing-редиректов (задача 71 §6.1,
 * минимальный слайс плана 73 §2.1).
 *
 * Десктоп-приложение не адаптировано под телефон. Мобильное устройство
 * руководителя юнита (лида — авторитет из орг-дерева, task 97) трактуем как
 * «PWA рабочего места», поэтому при входе с телефона редиректим его в мобильный
 * хаб, а не в office-`/home`. Сама проверка «лид» — не здесь, а в router-гейтах.
 *
 * Сигнал — **дизъюнкт** UA-маркера и `pointer: coarse`. Только ширина окна НЕ
 * годится: офисный на узком окне лэптопа (мышь → `pointer: fine`, desktop UA)
 * не должен залипнуть в мобильном вью. `pointer: coarse` истинно на тач-экранах
 * (телефон/планшет), а не при ресайзе окна мышью.
 */
const MOBILE_UA = /android|iphone|ipad|ipod|iemobile|blackberry|opera mini|mobile/i;

export function isMobileDevice(): boolean {
  if (typeof window === "undefined") return false;
  const coarse =
    typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches;
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  return coarse || MOBILE_UA.test(ua);
}
